import { Button, Col, Form, Row, Space, Spin, message } from 'antd';
import { InputFields } from 'components/common';
import React, { useEffect, useState } from 'react'
import { ModalEditConfig } from './ModalEdit.config';
import {analysisService} from "api";
import Notification from 'components/common/notification/notification';

const ModalEdit = (props) => {
  const {data, closeModal, type, getListDilate} = props;
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const [optionDV, setOptionDV] = useState([]);
  const [optionCS, setOptionCS] = useState([]);

  useEffect(() => {
    if (type == "Thêm") {
      form.resetFields();
    } else {
      form.setFieldsValue(data);
    }
  }, [data]);
  const addDilate = async () => {    
    setLoading(true);
    try {
      const params = form.getFieldsValue();
      const res = await analysisService.addCategoryIndex(params);
      setLoading(false);
      closeModal();
      await getListDilate();
    } catch (error) {
      setLoading(false);
      
      Notification("error", "Đã có lỗi xảy ra khi thêm mới");
    }
  };
  const editDilate = async (value) => {
    const newData = {
      ...value,
      id: data.id
    }
    setLoading(true);
    try {
      const params = form.getFieldsValue();
      const res = await analysisService.editCategoryIndex(newData.id,newData);
      setLoading(false);
      closeModal();
      await getListDilate();
    } catch (error) {
      setLoading(false);
      Notification("error", "Đã có lỗi xảy ra khi sửa");
    }
  };

  const getListDV = async () => {
     try {
      const res = await analysisService.getSearchDataDV("").then(res => {
        // console.log('res tim kiem dv', res);
        const newData = res.data.map(item => ({
          id: item.id,
          value: item.tenDichVu,
          label: item.tenDichVu,
          idNhomDichVu: item.idNhomDichVu,
          moTa: item.moTa
        }));
        setOptionDV(newData);  
      });
    } catch (error) {
      Notification("error", "Đã có lỗi xảy ra khi lấy danh mục dịch vụ");
    }
  }

  const getListCS = async () => {
    try {
      const res = await analysisService.getSearchDataCS("").then(res => {
        // console.log('res tim kiem chi so', res);
        const newData = res.data.map(item => ({
          id: item.id,
          value: item.tenChiSo,
          label: item.tenChiSo,
          donViTinh: item.donViTinh,
          moTa: item.moTa
        }));
        setOptionCS(newData);  
      });
    } catch (error) {
      Notification("error", "Đã có lỗi xảy ra khi lấy danh mục chỉ số");
    }
  }

  useEffect(()=>{
    getListDV();
    getListCS();
  },[type]);

  const onSelect = (value) => {
    const selectedOption: any = optionDV.find((option) => option.value === value);
    if (selectedOption) {
      form.setFieldValue("idDichVu",selectedOption.id);
    }
  }

  const onSelectCS = (value) => {
    const selectedOption: any = optionCS.find((option) => option.value === value);
    if (selectedOption) {
      form.setFieldValue("idChiSo",selectedOption.id);
    }
  }

  const onFinish = values => {
    if (type == "Thêm") {
      addDilate();
    } else {
      editDilate(values);
    }
  };
  return (
    <div>
      <Spin spinning={loading}>
        <Form form={form} onFinish={onFinish}>
          <Space direction="vertical" style={{width: "100%"}}>
            <Row gutter={[16, 16]}>
              <InputFields data={ModalEditConfig(optionDV, optionCS, onSelect, onSelectCS)}></InputFields>
            </Row>
            <Row justify="end">
              <Col>
                <Space>
                  <Button onClick={closeModal}>Hủy</Button>
                  <Button htmlType="submit" type="primary">
                    Xác nhận
                  </Button>
                </Space>{" "}
              </Col>
            </Row>
          </Space>
        </Form>
      </Spin>
    </div>
  );
}

export default ModalEdit